const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/frame/modal/user_menu.jsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import defaultUser from "../../../assets/images/default_user.png";
import { Button } from "primereact/button";
import { Card, Image } from "react-bootstrap";
import userpic from "./../../../assets/images/default_user.png"
import useSocialUserInfo from "../../utils/use_social_user_info";
import { useTranslation } from "react-i18next";

const UserMenu = () => {
    const { t } = useTranslation();
    const op = useRef(null);
    const [userInfo] = useSocialUserInfo();
    const userPicProfile = "data:image/jpeg;base64," + _optionalChain([userInfo, 'optionalAccess', _ => _.pic_profile]);
    const handleLogout = () => {
        console.log("logout called");
        localStorage.clear()
        setTimeout(() => {
            window.location.replace(`${process.env.REACT_APP_MAIN_URL}?logout=true`);
        }, 500);
    };
    const redirectProfile = () => {
        const cleanUrl = new URL(process.env.REACT_APP_SOCIAL_URL);
        window.location.assign(cleanUrl.origin + '/app/profile');
    }
    return (
        React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
            , React.createElement(Image, {
                src: _optionalChain([userInfo, 'optionalAccess', _2 => _2.pic_profile]) ? userPicProfile : defaultUser,
                className: "header-user-avatar cursor-pointer" ,
                onClick: (e) => op.current.toggle(e),
                alt: "User",
                width: 60,
                height: 60,
                roundedCircle: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
            )

            , React.createElement(OverlayPanel, {
                className: "user-menu d-flex justify-content-center align-items-end px-4 py-2"     ,
                style: { width: "300px", zIndex: 10000 },
                ref: op,
                dismissable: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

                , React.createElement(Card, { className: "p-2 mb-2 card-hover"  , onClick: () => redirectProfile(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
                    , React.createElement(Button, { className: "bg-transparent icon-link-hover border-none"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
                        , React.createElement(Image, {
                            src: _optionalChain([userInfo, 'optionalAccess', _3 => _3.pic_profile]) ? userPicProfile : userpic,
                            className: "header-profile-user-avatar me-2" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
                        )
                        , React.createElement('h6', { className: "text-color-ms white-space-nowrap" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, _optionalChain([userInfo, 'optionalAccess', _4 => _4.first_name]), " ", _optionalChain([userInfo, 'optionalAccess', _5 => _5.last_name]))
                    )

                )

                , React.createElement(Button, {
                    label: t("common.actions.logout"),
                    className: "p-button bg-orange2 w-100 user-menu-logout border-none"    ,
                    onClick: handleLogout, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
                )
            )
        )
    );
};

export default UserMenu;
